import { useTheme } from '@mui/material';
import { ISpeciesTable } from 'common/defines/analytic';
import ReactECharts from 'echarts-for-react';
import { FC } from 'react';

interface ChartSpeciesCountProps {
  chartData: ISpeciesTable[];
}

const ChartSpeciesCount: FC<ChartSpeciesCountProps> = ({ chartData }) => {
  const seriesData = chartData.map((item) => ({ value: item.count, name: item.name }));
  const theme = useTheme();

  const option = {
    tooltip: {
      trigger: 'item',
    },
    legend: {
      top: '0%',
      left: 'center',
      padding: [10, 0, 30, 0],
      textStyle: {
        color: theme.palette.mode === 'dark' ? '#fff' : '#333',
      },
    },
    series: [
      {
        name: '',
        type: 'pie',
        radius: ['30%', '60%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 10,
          borderColor: '#fff',
          borderWidth: 2,
        },
        label: {
          show: false,
          position: 'center',
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 20,
            fontWeight: 'bold',
          },
        },
        labelLine: {
          show: false,
        },
        data: seriesData,
      },
    ],
  };

  return <ReactECharts option={option} style={{ height: '360px', width: '100%' }} />;
};

export default ChartSpeciesCount;
